import AxiosConfig from "@/config/axiosConfig/AxiosConfig";
import config from "@/config";

const IndustrialService = {
    getIndustrial: async (params) => {
        try {
            const response = await AxiosConfig.get(config.api.industrial, { params }, {
                timeout: 100000,
            });
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },
    getId: async (id) => {
        try {
            const response = await AxiosConfig.get(config.api.industrial + `/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },
    getIndustrialUrgent: async (params) => {
        try {
            const response = await AxiosConfig.get(config.api.industrialUrgent, { params });
            return response.data;
        } catch (error) {
            console.error('Error:', error);
            return Promise.reject(error);
        }
    },
}

export default IndustrialService